import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=3ebdd0d0&scoped=true"
import script from "@/components/shopping-cart/ShoppingCart.ts?vue&type=script&lang=ts&external"
export * from "@/components/shopping-cart/ShoppingCart.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/shopping-cart/shopping-cart.scss?vue&type=style&index=0&id=3ebdd0d0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebdd0d0",
  null
  
)

export default component.exports